import { Link } from 'react-router-dom';

const Admission = () => {
  return (
    <>
      <section className="bg-gradient-to-r from-primary to-primary-600 text-white py-20 text-center">
        <div className="container">
          <h1 className="text-5xl font-bold mb-4">Admission</h1>
          <p className="text-xl max-w-2xl mx-auto">Join our family - simple online application</p>
        </div>
      </section>
      
      <section className="py-24 bg-slate-50">
        <div className="container">
          <div className="max-w-4xl mx-auto text-center">
            <div className="bg-white rounded-3xl p-16 shadow-2xl">
              <i className="fas fa-user-plus text-8xl text-primary mb-8"></i>
              <h2 className="text-4xl font-bold mb-8">Ready to Start Your Journey?</h2>
              <p className="text-xl text-slate-600 mb-12">Apply online or contact us for details.</p>
              <div className="flex flex-wrap justify-center gap-4">
                <Link to="/auth/student-register" className="bg-gradient-to-r from-primary to-primary-600 hover:from-primary-600 hover:to-primary-700 text-white px-12 py-4 rounded-2xl font-bold text-xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all inline-flex items-center gap-3">
                  <i className="fas fa-edit"></i>
                  Register Online
                </Link>
                <Link to="/contact" className="border-2 border-primary text-primary hover:bg-primary hover:text-white px-12 py-4 rounded-2xl font-bold text-xl shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all inline-flex items-center gap-3">
                  <i className="fas fa-envelope"></i>
                  Contact Admissions
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Admission;

